<template>
  <div
    id="neoronChat-component"
    :class="
      channel == 'widget'
        ? 'neoronChat chat-page widget'
        : 'neoronChat chat-page'
    "
  >
    <a-modal
      :visible="
        openSendModal &&
        file &&
        (file?.type?.includes('image') || file?.type?.includes('video'))
      "
      :closable="false"
    >
      <div class="container-preview">
        <img
          id="img-preview"
          :src="imgPreviewBeforeSend"
          v-if="file?.type.includes('image')"
        />

        <video
          id="video-preview"
          :src="videoPreviewBeforeSend"
          v-if="file?.type.includes('video')"
          controls
        >
          <source :type="file?.type" :src="videoPreviewBeforeSend" />
        </video>
        <font-awesome-icon
          icon="file"
          class="others-documents"
          v-if="!file?.type.includes('video') && !file?.type.includes('image')"
        />
        <span
          class="file-name"
          v-if="!file?.type.includes('video') && !file?.type.includes('image')"
        >
          {{ file?.name }}
        </span>
      </div>

      <template #footer>
        <a-button @click="closeSendModal">Fechar</a-button>
        <a-button @click="handlerSend" type="primary">Enviar</a-button>
      </template>
    </a-modal>
    <div class="neoronChat msg-inbox">
      <div class="neoronChat chats" id="chats">
        <div class="neoronChat msg-page" id="msg-page">
          <div style="display: flex; flex-direction: column">
            <div
              :class="
                channel == 'widget'
                  ? 'neoronChat card-list simulator-chat-widget'
                  : 'neoronChat card-list simulator-chat'
              "
              ref="list_converations"
            >
              <transition-group name="fade">
                <div v-for="(message, index) in groupMessages" :key="index">
                  <div
                    :style="
                      showFormModal && channel == 'landing'
                        ? 'filter: blur(2px)'
                        : 'filter: none'
                    "
                  >
                    <div
                      class="neoronChat row"
                      style="justify-content: flex-end"
                      v-if="message && message.sender.user !== 'bot'"
                    >
                      <div
                        class="neoronChat received-chats"
                        :style="{
                          background: channel_config.background_received,
                        }"
                      >
                        <div
                          class="neoronChat row"
                          style="justify-content: flex-end"
                        ></div>
                        <div class="neoronChat received-msg">
                          <div
                            class="neoronChat received-msg-inbox"
                            :style="
                              !enabled_chat ? { filter: 'blur(3px)' } : {}
                            "
                          >
                            <div
                              v-html="sanitizeHTML(message.data.text)"
                              :style="{
                                color: channel_config.font_color_received,
                              }"
                              v-if="message.data.text"
                            />
                            <img
                              :src="message.data.content"
                              alt=""
                              v-else-if="message.data.isImg"
                            />
                            <p
                              v-html="sanitizeHTML(message.data.content)"
                              :style="{
                                color: channel_config.font_color_outgoing,
                              }"
                              v-else-if="message.data.content"
                            ></p>

                            <img
                              v-if="
                                message?.data.isFile &&
                                message?.data.fileType.includes('image')
                              "
                              class="incoming-chats-img"
                              @click="
                                openImagePreview(
                                  message?.data.file.url,
                                  message?.data.file.name
                                )
                              "
                              :src="message?.data.file.url"
                              :alt="message?.data.file.name"
                            />

                            <audio
                              style="padding-right: 25px"
                              controls
                              :src="message?.data.file.url"
                              v-if="
                                message?.data.isFile &&
                                message?.data.fileType.includes('audio')
                              "
                            ></audio>

                            <video
                              style="width: 100%"
                              controls
                              :src="message?.data.file?.url"
                              v-if="
                                message?.data.isFile &&
                                message?.data.fileType.includes('video')
                              "
                            >
                              <source
                                :src="message?.data.file?.url"
                                :type="message?.data.fileType"
                              />
                            </video>

                            <a
                              v-if="
                                message?.data.isFile &&
                                !message?.data.fileType.includes('image') &&
                                !message?.data.fileType.includes('video') &&
                                !message?.data.fileType.includes('audio')
                              "
                              :href="message?.data.file.url"
                              target="_blank"
                              :style="{
                                color: channel_config.font_color_incoming,
                              }"
                            >
                              <span
                                v-if="message?.data.file.name"
                                v-html="sanitizeHTML(message?.data.file.name)"
                              ></span>
                              {{ " " }}
                              <font-awesome-icon icon="download" />
                            </a>
                          </div>
                        </div>
                      </div>
                      <div
                        class="time_current"
                        v-if="message.created_date"
                        style="
                          text-align: right;
                          margin-top: -15px;
                          padding-right: 8px;
                        "
                      >
                        <span>{{ message.created_date }}</span>
                      </div>
                    </div>
                    <div class="neoronChat row" v-else>
                      <!-- {{enabled_chat}} -->
                      <div style="width: 100%" v-if="message.data.component">
                        <div class="neoronChat outgoing-chats-msg">
                          <options
                            @formModal="handleForm($event, status)"
                            @direct="handleSendByOptions($event, message.id)"
                            @carousel="handleSendCarousel($event, message.id)"
                            :content="{ object: message.data.component }"
                            :showFormModal="showFormModal"
                            :channel="channel"
                            v-if="enabled_chat"
                          />
                        </div>
                      </div>
                      <div
                        class="neoronChat outgoing-chats"
                        :style="{
                          background: channel_config.background_outgoing,
                        }"
                        v-else
                      >
                        <div
                          class="neoronChat outgoing-chats-msg"
                          :style="!enabled_chat ? { filter: 'blur(3px)' } : {}"
                        >
                          <p
                            v-html="sanitizeHTML(message.data.text)"
                            :style="{
                              color: channel_config.font_color_outgoing,
                            }"
                            v-if="
                              message.data.text || message.data.type === 'media'
                            "
                          ></p>

                          <img
                            v-if="
                              message?.data.isFile &&
                              message?.data.file.type.includes('image')
                            "
                            class="outgoing-chats-img"
                            @click="
                              openImagePreview(
                                message?.data.file.url,
                                message?.data.file.filename
                              )
                            "
                            :src="message?.data.file.url"
                            :alt="message?.data.file.filename"
                          />

                          <audio
                            style="padding-right: 10px"
                            controls
                            :src="message?.data.file.url"
                            v-if="
                              message?.data.isFile &&
                              message?.data.file.type.includes('audio')
                            "
                          ></audio>

                          <video
                            controls
                            v-if="
                              message?.data.isFile &&
                              message?.data.file.type.includes('video')
                            "
                          >
                            <source
                              :src="message?.data.file.url"
                              :type="message?.data.file.type"
                            />
                          </video>

                          <a
                            v-if="
                              message?.data.isFile &&
                              !message?.data.file.type.includes('image') &&
                              !message?.data.file.type.includes('video') &&
                              !message?.data.file.type.includes('audio')
                            "
                            :href="message?.data.file.url"
                            target="_blank"
                            :style="{
                              color: channel_config.font_color_incoming,
                            }"
                          >
                            <span
                              v-if="message?.data.file.filename"
                              v-html="sanitizeHTML(message?.data.file.filename)"
                            ></span>
                            {{ " " }}
                            <font-awesome-icon icon="download" />
                          </a>
                        </div>
                      </div>
                      <div
                        class="time_current"
                        v-if="message.created_date"
                        style="text-align: left; margin-top: -5px"
                      >
                        <span>{{ message.created_date }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </transition-group>
              <div
                class="neoronChat loading-msg"
                v-if="loadingMessages || processingMessages"
              >
                <div class="neoronChat spinner">
                  <div class="neoronChat bounce1"></div>
                  <div class="neoronChat bounce2"></div>
                  <div class="neoronChat bounce3"></div>
                </div>
              </div>
            </div>
            <image-preview
              :src="imagePreview"
              :alt="imagePreviewAlt"
              :show="showImagePreview"
              :handleOnClose="handleOnCloseImagePreview"
            ></image-preview>
            <div
              class="neoronChat msg-bottom"
              v-if="!showFormModal"
              :class="channel == 'widget' ? 'widget' : ''"
              :style="
                showFormModal && channel == 'landing'
                  ? 'filter: blur(2px)'
                  : 'filter: none'
              "
            >
              <form
                class="neoronChat message-form"
                v-on:submit.prevent="sendGroupMessage"
              >
                <div
                  :class="
                    channel === 'widget'
                      ? 'neoronChat input-group-widget'
                      : 'neoronChat input-group'
                  "
                >
                  <div
                    :style="
                      file && channel === 'widget'
                        ? { marginBlock: '15px !important' }
                        : {}
                    "
                    class="box-input"
                    v-if="
                      !(!enabled_chat || inputChat || lastButton || locked_chat) || (chatState === 'takeover_session' || chatState === 'takeover' ||  chatState === 'start_takeover')
                    "
                  >
                    <div class="preview-inputs">
                      <div class="buttons-group" v-if="!recording">
                        <label
                          for="upload-file"
                          :style="
                            file && channel === 'widget'
                              ? { marginTop: '-10px !important' }
                              : {}
                          "
                        >
                          <font-awesome-icon
                            icon="paperclip"
                            :class="
                              channel === 'widget'
                                ? 'clip-icon widget'
                                : 'clip-icon'
                            "
                          />
                          <input
                            @change="uploadFile"
                            type="file"
                            id="upload-file"
                            style="display: none"
                          />
                        </label>
                      </div>

                      <div class="attach-file" v-if="!recording && file">
                        {{
                          channel !== "widget"
                            ? file.name
                            : file.name.substr(0, 25) + "..."
                        }}
                        <font-awesome-icon
                          class="delete-file"
                          icon="trash"
                          @click="deleteFile"
                        />
                      </div>
                    </div>

                    <textarea
                      v-if="!recording && !file"
                      type="text"
                      :rows="channel === 'widget' ? 3 : 2"
                      :class="
                        [
                          'neoronChat form-control message-input',
                          disableInput,
                          channel == 'widget' ? 'widget' : '',
                        ].join(' ')
                      "
                      :placeholder="placeholder"
                      @keyup.enter="handlerSend"
                      v-model="chatMessage"
                      ref="inputChatField"
                    />

                    <div
                      :class="
                        channel === 'widget' ? 'recording widget' : 'recording'
                      "
                      v-if="recording"
                    >
                      <font-awesome-icon
                        class="delete-icon"
                        icon="trash"
                        @click="deleteAudio"
                      />
                      <span v-if="!viewPreviewAudio" class="audio-status">{{
                        timer
                      }}</span>
                      <audio v-else controls :src="audioUrl"></audio>
                      <font-awesome-icon
                        class="pause-icon"
                        v-if="!viewPreviewAudio"
                        @click="stopRecordAudio"
                        icon="pause"
                      />
                    </div>

                    <a
                      v-if="
                        ((chatMessage !== '' && chatMessage !== undefined) ||
                          file) &&
                        !sendingMessage
                      "
                      :style="
                        viewPreviewAudio && channel === 'widget'
                          ? { marginTop: '28px' }
                          : { marginTop: '10px' }
                      "
                      :class="
                        channel == 'widget' ? 'icon-send widget' : 'icon-send'
                      "
                      @click.prevent="handlerSend"
                    >
                      <font-awesome-icon
                        class="paper-plane"
                        icon="paper-plane"
                      />
                    </a>

                    <div
                      v-else-if="
                        ((chatMessage !== '' && chatMessage !== undefined) ||
                          file) &&
                        sendingMessage
                      "
                      :class="
                        channel == 'widget' ? 'icon-send widget' : 'icon-send'
                      "
                    >
                      <a-icon
                        :style="{
                          fontSize: '20px',
                          width: '70%',
                          marginTop: '5px',
                          color: '#1890ff',
                        }"
                        type="loading"
                        :spin="true"
                      />
                    </div>

                    <div
                      v-else
                      :class="
                        channel == 'widget' ? 'icon-send widget' : 'icon-send'
                      "
                    >
                      <div
                        v-if="!viewPreviewAudio && !recording && (chatState === 'takeover_session' || chatState === 'takeover' ||  chatState === 'start_takeover')"
                        :class="micIconActive"
                        @click="micCallFunction"
                      >
                        <font-awesome-icon icon="microphone" />
                      </div>

                      <div
                        @click.prevent="handlerSend"
                        :class="
                          channel == 'widget' ? 'icon-send widget' : 'icon-send'
                        "
                        v-else-if="viewPreviewAudio && !sendingMessage"
                      >
                        <font-awesome-icon
                          class="paper-plane"
                          icon="paper-plane"
                        />
                      </div>

                      <div
                        :class="
                          channel == 'widget' ? 'icon-send widget' : 'icon-send'
                        "
                        v-else-if="viewPreviewAudio && sendingMessage"
                      >
                        <a-icon
                          :style="{
                            fontSize: '20px',
                            width: '70%',
                            marginTop: '5px',
                            color: '#1890ff',
                          }"
                          type="loading"
                          :spin="true"
                        />
                      </div>
                    </div>
                  </div>

                  <p v-if="disclaimerText" class="disclaimer">
                    {{ disclaimerText }}
                  </p>

                  <div class="neoronChat brand-group">
                    <a
                      href="https://neoron.io/"
                      target="_blank"
                      rel="noopener noreferrer"
                      v-if="!white_label"
                    >
                      <p class="powered">
                        powered by
                        <img
                          :src="logo_blue"
                          alt="neoron"
                          width="15"
                          height="15"
                        />NEORON
                      </p>
                    </a>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="anchor" style="display: none">{{ groupMessages }}</div>
  </div>
</template>

<script>
import "ant-design-vue/dist/antd.css";
import Options from "./OptionsRender";
import avatarImg from "@/assets/img/profile.png";
import imgLogo from "@/assets/img/neoron-icons.png";
import { mapState } from "vuex";
import { LoadingOutlined } from "@ant-design/icons-vue";
import { AButton, AIcon, AModal } from "../../../components/antd";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import ImagePreview from "../components/ImagePreview.vue";
import dayjs from "dayjs";
import {
  faPaperPlane,
  faTrash,
  faPaperclip,
  faPause,
  faMicrophone,
  faDownload,
  faFile,
} from "@fortawesome/free-solid-svg-icons";
import { library } from "@fortawesome/fontawesome-svg-core";
import DOMPurify from "dompurify";

library.add(faPaperPlane);
library.add(faTrash);
library.add(faPaperclip);
library.add(faPause);
library.add(faMicrophone);
library.add(faDownload);
library.add(faFile);

export default {
  components: {
    Options,
    ImagePreview,
    FontAwesomeIcon,
    AIcon,
    AModal,
    AButton,
  },
  props: {
    bot_id: {
      type: String,
      required: true,
      default: "",
    },
    initial_data: {
      type: Object,
      default: null,
    },
    channel: {
      type: String,
      default: "landing",
    },
    white_label:{
      type: Boolean,
      default: false,
    },    
    channel_config: {
      type: Object,
      required: false,
      default: () => ({
        background_received: "#4d4b4b",
        background_outgoing: "#f1f1f1",
        font_color_received: "#fff",
        font_color_outgoing: "#000",
      }),
    },
    simulator_mode: {
      type: Boolean,
      required: false,
      default: false,
    },
    enabled_chat: {
      type: Boolean,
      required: false,
      default: true,
    },
  },

  data() {
    return {
      reader: new FileReader(),
      username: "",
      avatar: "",
      uid: "",
      bot: {},
      loadingIcon: LoadingOutlined,
      contentRender: {},
      sendingMessage: false,
      chatMessage: "",
      loggingOut: false,
      groupMessages: [],
      loadingMessages: false,
      stateOut: false,
      stateReceived: false,
      message: {
        data: {
          text: "resposta...",
        },
      },
      widthScreen: 0,
      borderColorOk: true,
      captureMode: false,
      captureObject: {},
      dataRecordResponseContinue: [],
      disableInput: "active",
      inputChat: false,
      updateMessage: [],
      logo_blue: imgLogo,
      locked_chat: true,
      lastButton: false,
      showFormModal: false,
      mediaRecorder: undefined,
      recording: false,
      viewPreviewAudio: false,
      audioUrl: "",
      cronAudio: undefined,
      streamer: undefined,
      secondsAudio: 0,
      minutesAudio: 0,
      timer: "00:00",
      file: undefined,
      imagePreview: "",
      imagePreviewAlt: "",
      showImagePreview: false,
      openSendModal: false,
      imgPreviewBeforeSend: null,
      videoPreviewBeforeSend: null,
    };
  },

  async mounted() {
    this.loadingMessages = true;

    window.addEventListener("resize", () => this.mobileScreen());
    this.mobileScreen();
    console.log(this.$props)
    if (this.bot_id) {
      this.$store
        .dispatch("chat/initializeChat", {
          bot_id: this.bot_id,
          data: this.initial_data,
          simulator_mode: this.simulator_mode,
        })
        .then(() => {
          this.loadingMessages = false;
        });
    }
  },

  updated() {
    this.$nextTick(() => this.onScroll());
  },

  computed: {
    micIconActive() {
      return !this.reconding ? "mic-icon" : "active-mic-icon";
    },

    disclaimerText() {
      return this.$store.state.config_landing.disclaimer_text;
    },

    borderColor: {
      get() {
        if (this.borderColorOk) {
          return { borderColor: "#b5b1b1" };
        }
        return { borderColor: "red" };
      },

      set(val) {
        this.borderColor = val;
      },
    },

    ...mapState({
      async refresh(state) {
        if (state.chat.chatRefresh) {
          this.groupMessages = [];
          setTimeout(() => {
            this.$store.dispatch("chat/offRefreshSimulator");
          }, 2000);
          this.$store.dispatch("chat/initializeChat", {
            bot_id: this.bot_id,
            data: await this.initialData,
          });
          return true;
        } else {
          return false;
        }
      },

      botInfo: (state) => state.bot,

      placeholder: (state) => state.bot.placeholder,

      callSimulator: (state) => state.chat.callSimulator,

      chatState: (state) => state.chat.chatState,

      locked: (state) => state.chat.locked,

      processingMessages: (state) => state.chat.loading,
    }),

    getMessageUpdate() {
      return this.$store.state.chat.messages;
    },
  },

  watch: {

    async callSimulator(val){
      if(val){
         await this.sleep(100);
        this.onScroll();
      }
    },

    groupMessages(val) {
      setTimeout(() => this.onScroll(), 200);
    },

    getMessageUpdate(val) {
      if(this.groupMessages.length === 0){
        this.processResponseList(val);
        return;
      }

      this.updateMessage = val[val.length - 1];
      this.processResponse(this.updateMessage, false);
    },

    bot_id(val) {
      if (this.bot_id) {
        this.$store
          .dispatch("chat/initializeChat", {
            bot_id: this.bot_id,
            data: this.initial_data,
            simulator_mode: this.simulator_mode,
          })
          .then(() => {
            this.loadingMessages = false;
          });
      }
    },

    locked(val) {
      if (val) {
        this.locked_chat = true;
      } else if (!this.lastButton) {
        this.locked_chat = false;
      }
    },
  },

  methods: {
    sanitizeHTML(data){
     return DOMPurify.sanitize(data);
    },
    
    closeSendModal() {
      this.openSendModal = false;
    },

    openImagePreview(url, alt) {
      this.imagePreview = url;
      this.imagePreviewAlt = alt;
      this.showImagePreview = true;
    },

    handleOnCloseImagePreview(state) {
      this.showImagePreview = state;
    },

    sleep(ms) {
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve({});
        }, ms);
      });
    },

    mobileScreen() {
      this.widthScreen = window.innerWidth;
      if (this.widthScreen < 801) {
        this.mobileHeight = { height: `${window.innerHeight}px` };
      } else {
        this.mobileHeight = { height: `100%` };
      }
    },

    validateField() {
      if ((this.chatMessage && this.chatMessage.trim() !== "") || this.file) {
        return true;
      }
      return false;
    },

    readFile(file){
      return new Promise((resolve, reject) => {
        const reader = this.reader;

        reader.onload = async () => {
          try {
            resolve({ url: reader.result });
          } catch (err) {
            reject(err);
          }
        };
        reader.onerror = (error) => {
          reject(error);
        };
        reader.readAsDataURL(file);
      });
    },

    async handlerSend() {
      if (this.validateField()) {
        this.sendingMessage = true;
        this.chatMessage = this.chatMessage?.trim();
        this.borderColorOk = true;
        this.recording = false;
        this.viewPreviewAudio = false;

        var msg = {
          id: Date.now(),
          sender: {
            avatar: "",
            uid: "user",
          },
          data: {
            text: this.chatMessage,
          },
        };

        msg.created_date = await dayjs(msg.id).format("HH:mm");
        this.chatMessage = "";

        if (this.file) {
          msg.data.isFile = true;
          msg.data.fileType = "other";
          this.openSendModal = false;
          this.$store.dispatch("chat/sendFile", {
            file: this.file,
          });
          msg.data.file  = await this.readFile(this.file);

          if (this.file?.type.includes("audio")) {
            this.deleteAudio();
            msg.data.fileType = "audio";
          } else if (this.file?.type.includes("image")) {
            msg.data.fileType = "image";
          } else if (this.file?.type.includes("video")) {
            msg.data.fileType = "video";
          }

          if (!this.file?.type || !this.file?.type?.includes("audio")) {
            this.deleteFile();
          }

          this.groupMessages.push(msg);
          this.sendingMessage = false;
          this.locked_chat = false;
          return;
        }

        let chatMsg = msg.data.text;
        this.groupMessages.push(msg);

        await this.$store
          .dispatch("chat/sendMessage", {
            query: { text: chatMsg, type: "text" },
          })
          .then((response) => {
            !response ? "" : "";
          });

        this.sendingMessage = false;
      }
    },

    async handleSendByOptions(content, msgID) {
      var msg = await content.value;
      var msgBot = await {
        id: Date.now(),
        sender: {
          avatar: "",
          uid: "user",
        },
        data: {
          text: msg,
          card_id: content.idCard,
          isImg: content.isImg,
        },
      };

      msgBot.created_date = await dayjs(msgBot.id).format("HH:mm");
      this.groupMessages.push(msgBot);
      this.groupMessages.map((msg, index) => {
        if (msg.id === msgID) {
          this.groupMessages.splice(index, 1);
        }
      });

      this.onScroll();
      this.loadingMessages = true;

      let query = { text: msg, card_id: content.idCard, type: "options" };

      if (content.form_data && content.form_settings) {
        query.form_data = content.form_data;
        query.form_settings = content.form_settings;
      }

      this.$store.dispatch("chat/sendMessage", { query }).then((response) => {
        !response ? "" : "";
        this.chatMessage = "";
      });
    },

    sendGroupMessage() {
      this.sendingMessage = true;
    },

    onScroll() {
      this.$refs.list_converations.scrollTop =
        this.$refs.list_converations.scrollHeight;
    },

    async processResponseList(messages){
      const total = messages.length;

      for(let index = 0; index < total; index++){
        const isLastMessage = index === (total - 1);
        const message = messages[index];

        if(!isLastMessage || message.sender === 'user'){
          await this.processResponse(message, true);
          continue;
        }

        await this.processResponse(message, false);
      }
    },

    async processResponse(message, initial_load) {
      const messageProcessor = {
        text: (msg) => {
          return {
            id: Date.now(),
            sender: {
              user: "bot",
            },
            data: {
              text: msg.content,
            },
          };
        },
        media: (msg) => {
          return {
            id: Date.now(),
            sender: {
              user: "bot",
            },
            data: {
              text: msg.content,
            },
          };
        },
        file: (msg) => {
          return {
            id: Date.now,
            sender: {
              user: "bot",
            },
            data: {
              text: "",
              isFile: true,
              file: {
                filename: msg.filename,
                type: msg.type,
                url: msg.url,
              },
            },
          };
        },
        button: (msg) => {
          return {
            id: Date.now(),
            sender: {
              user: "bot",
            },
            data: {
              component: msg,
            },
          };
        },
        capture_carousel: (msg) => {
          return {
            id: Date.now(),
            sender: {
              user: "bot",
            },
            data: {
              component: msg,
            },
          };
        },
        form: (msg) => {
          return {
            id: Date.now(),
            sender: {
              user: "bot",
            },
            data: {
              component: msg,
            },
          };
        },
      };

      if (message && message.sender !== "user" && message.message_list) {
        let message_list = message.message_list;
        let isLastButton = false;
        let created_date = message.created_date;

        for (let m = 0; m < message_list.length; m++) {
          let msg = message_list[m];
          let msg_list_size = message_list.length - 1;
          let messageType = msg.type;

          if (
            msg.type &&
            msg.type !== "button" &&
            msg.type !== "capture_carousel" &&
            msg.type !== "form" &&
            msg.type !== "text" &&
            msg.type !== "media"
          ) {
            messageType = "file";
          }

          if (
            msg.type != undefined &&
            typeof msg.type === "string" &&
            Object.keys(messageProcessor).includes(messageType)
          ) {
            let newMsg = messageProcessor[messageType](msg);
            if (msg.type === "button"  && !initial_load) {
              isLastButton = true;
            }

            if (msg.type === "capture_carousel" && !initial_load) {
              let buttonEnbled = msg.content;

              const isButtonDirectToCard = (cards) => {
                let enable = false;
                cards.map((card) => {
                  if (card.directToCardEnable) {
                    enable = true;
                  }
                });

                return enable;
              };

              this.locked_chat = isButtonDirectToCard(buttonEnbled.cards);
              isLastButton = this.locked_chat;
            }

            if (msg.type === "form"  && !initial_load) {
              this.showFormModal = true;
            }

            if(!initial_load){
              this.loadingMessages = true;
              const min = 500;
              const max = 700;
              const sleepTime = Math.floor(Math.random() * (max - min + 1) + min);
              await this.sleep(sleepTime);

              this.loadingMessages = false;
            }

            if (
              (msg.type !== "button" && m === msg_list_size) ||
              (m === msg_list_size - 1 &&
                message_list[msg_list_size].type === "button")
            ) {
              newMsg.created_date = await dayjs(created_date).format("HH:mm");
            }

            if((msg.type === "text" || msg.type === "media" || msg.type === "capture_carousel" || messageType === 'file' ) || !initial_load){
              this.groupMessages.push(newMsg);
              this.onScroll();
            }

          }
        }

        this.lastButton = isLastButton;

        if (!this.locked && !isLastButton) {
          this.locked_chat = false;
          this.focusInput();
        }
        return;
      }

      if(message && message.sender === "user" && initial_load){
          let data = {
            text: message.message.content
          }

          if(message.message.file){
            message.message.file = {
              url: message.message.file
            }
            data = message.message;
          }

          const formatedDate = await dayjs(message.created_date).format("HH:mm");

          const msg = {
            id: message.created_date,
            created_date: formatedDate,
            sender: {
            avatar: "",
            uid: "user",
            },
            data,
          };
        this.groupMessages.push(msg);
      }
    },

    async handleSendCarousel(content, msgID) {
      var msg = await content.value;
      var msgBot = await {
        id: Date.now(),
        sender: {
          avatar: "",
          uid: "user",
        },
        data: {
          content: msg,
          card_id: content.directToCard,
          isImg: content.isImg,
        },
      };
      msgBot.created_date = await dayjs(msgBot.id).format("HH:mm");
      this.groupMessages.push(msgBot);

      this.groupMessages.map((msg, index) => {
        if (msg.id === msgID) {
          this.groupMessages.splice(index, 1);
        }
      });

      this.onScroll();
      this.loadingMessages = true;

      this.$store
        .dispatch("chat/sendMessage", {
          query: {
            content: msg,
            card_id: content.directToCard,
            type: "options",
          },
        })
        .then((response) => {
          !response ? "" : "";
          this.chatMessage = "";
        });
    },

    focusInput() {
      if (window.innerWidth > 800) {
        this.$nextTick(() => {
          this.$refs.inputChatField?.focus();
        });
      } else {
        let cardList = window.document.querySelector(".card-list");
        if (this.channel !== "widget") {
          setTimeout(() => {
            cardList.scrollTo(0, cardList.scrollHeight + 200);
          }, 2500);
        }
      }
    },

    handleForm(status) {
      this.showFormModal = status;
    },

    async generateFilePreview(file) {
      if (FileReader && file) {
        const fileReader = new FileReader();
        const vm = this;

        fileReader.onload = function () {
          if (fileReader.result.includes("image")) {
            vm.imgPreviewBeforeSend = fileReader.result;
          }
          if (fileReader.result.includes("video")) {
            vm.videoPreviewBeforeSend = fileReader.result;
          }
        };

        fileReader.readAsDataURL(file);
      }
    },

    async uploadFile(event) {
      this.file = event.target.files[0];
      await this.generateFilePreview(this.file);
      this.openSendModal = true;
    },

    deleteFile() {
      this.file = undefined;
      this.imgPreviewBeforeSend = undefined;
      this.videoPreviewBeforeSend = undefined;
      const inputFile = document.getElementById("upload-file");

      if (inputFile) {
        inputFile.value = "";
      }
    },

    deleteAudio() {
      this.audioUrl = "";
      this.viewPreviewAudio = false;
      this.recording = false;
      this.mediaRecorder = undefined;
      this.minutesAudio = 0;
      this.secondsAudio = 0;
      this.timer = "00:00";
      this.file = undefined;

      clearInterval(this.cronAudio);

      this.streamer.then((stream) => {
        stream.getTracks().forEach(function (track) {
          track.stop();
        });
      });
    },

    startTimeAudio() {
      this.secondsAudio++;

      if (this.secondsAudio === 60) {
        this.secondsAudio = 0;
        this.minutesAudio++;

        if (this.minutesAudio === 60) {
          this.minutesAudio = 0;
          this.secondsAudio = 0;
        }
      }

      this.timer =
        (this.minutesAudio < 10 ? "0" + this.minutesAudio : this.minutesAudio) +
        ":" +
        (this.secondsAudio < 10 ? "0" + this.secondsAudio : this.secondsAudio);
    },

    recordAudio() {
      this.cronAudio = setInterval(() => {
        this.startTimeAudio();
      }, 1000);

      this.streamer = navigator.mediaDevices.getUserMedia({
        audio: true,
        video: false,
      });

      this.streamer.then((stream) => {
        this.recording = true;

        this.mediaRecorder = new MediaRecorder(stream, {
          mimeType: "audio/webm;codecs=opus",
        });

        this.mediaRecorder.start();
        const chunk = [];

        this.mediaRecorder.addEventListener("dataavailable", (e) => {
          chunk.push(e.data);
        });

        this.mediaRecorder.addEventListener("stop", async (e) => {
          const blob = new Blob(chunk, { type: "audio/webm;codecs=opus" });

          this.file = new File([blob], "audio.webm", {
            type: "audio/webm;codecs=opus",
          });

          this.audioUrl = URL.createObjectURL(blob);
        });
      });
    },

    stopRecordAudio() {
      this.viewPreviewAudio = true;
      this.minutesAudio = 0;
      this.secondsAudio = 0;
      this.timer = "00:00";

      clearInterval(this.cronAudio);

      if (this.mediaRecorder) {
        this.mediaRecorder.stop();
      }

      this.streamer.then((stream) => {
        stream.getTracks().forEach(function (track) {
          track.stop();
        });
      });
    },

    micCallFunction() {
      return this.recording ? this.stopRecordAudio() : this.recordAudio();
    },
  },
};
</script>

<style lang="scss">
.chat-page.neoronChat {
  @import url(https://fonts.googleapis.com/css?family=Nunito:400);

  a {
    color: #1890ff;
    text-decoration: none;
    background-color: transparent;
    outline: none;
    cursor: pointer;

    &:hover {
      color: #40a9ff;
      text-decoration: none;
    }

    &:active,
    a:hover {
      text-decoration: none;
      outline: 0;
    }
  }

  display: flex;
  flex-direction: column;
  height: 100%;

  &.widget {
    height: 96%;
  }

  div,
  p,
  span,
  a,
  button,
  input,
  textarea {
    font-family: "Nunito", sans-serif;
    font-weight: 400;
    font-size: 17px;
  }

  @media (max-width: 600px) {
    div,
    p,
    span,
    a,
    button,
    input,
    textarea {
      font-size: 14px;
    }
  }

  .powered {
    font-size: 12px;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 5px;

    @media (max-width: 780px) {
      margin-top: 0;
    }

    img {
      margin: 0px 3px 0px 5px;
      width: 15px !important;
    }
  }

  .msg-inbox {
    height: 100%;

    .chats {
      height: 100%;

      .msg-page {
        height: 82vh;

        @media screen and (max-height: 624px) {
          height: 80vh;
        }

        @media screen and (min-height: 625px) and (max-height: 891px) {
          height: 82vh;
        }

        @media screen and (min-height: 892px) and (max-height: 1560px) {
          height: 86vh;
        }

        & > div {
          height: 100%;
        }
      }
    }

    .card-list.simulator-chat {
      color: #000;
      margin-bottom: 0;
      overflow-y: auto;
      overflow-x: hidden;
      margin: 0px 0.4px 0 4;
      padding: 8px 12px 0px 5px;
      z-index: 1;
      min-height: 0;
      height: 75%;

      @media (max-width: 600px) {
        bottom: 10px;
      }

      &::-webkit-scrollbar {
        width: 6px;
        background-color: rgba(0, 0, 0, 0.08);
        outline: 1px solid rgba(71, 71, 71, 0.075);
      }

      &::-webkit-scrollbar-thumb {
        background-color: rgb(218, 209, 209);
      }

      & .activeComputed {
        display: none;
      }
    }

    .card-list.simulator-chat-widget {
      color: #000;
      flex: 1 1 auto;
      margin-bottom: 10px;
      overflow-y: auto;
      overflow-x: hidden;
      padding: 8px 12px 0px 5px;
      z-index: 1;
      min-height: 0;

      #modal-form {
        @media (max-width: 768px) {
          position: fixed;
          top: 0;
          right: 0;
          left: 0;
          bottom: 0;
          z-index: 100;
        }

        .ant-modal-wrap {
          position: absolute;

          @media (max-width: 768px) {
            position: fixed;
          }
        }

        .ant-modal {
          width: 100% !important;

          @media (max-width: 768px) {
            top: 0;
            padding: 0;
            margin: 0;
            max-width: 100%;
          }

          p {
            margin: 0 0 0 10px;
          }

          .ant-modal-content {
            @media (max-width: 768px) {
              width: 100%;
              height: 100%;
            }

            padding-top: 30px;

            .list-fields {
              .required-hint {
                margin-top: 2px;
                text-align: left;
                margin-left: 5px;
                color: red;
              }
            }
          }
        }
      }

      @media (max-width: 600px) {
        bottom: 10px;
        max-height: 85%;
      }

      &::-webkit-scrollbar {
        width: 6px;
        background-color: rgba(0, 0, 0, 0.08);
        outline: 1px solid rgba(71, 71, 71, 0.075);
      }

      &::-webkit-scrollbar-thumb {
        background-color: rgb(218, 209, 209);
      }

      & .activeComputed {
        display: none;
      }
    }

    .msg-bottom {
      z-index: 1;
      margin: auto -22px 0 -22px;

      &.widget {
        margin: 0;
        z-index: 0;
        display: flex;
        filter: none;
        justify-content: flex-end;
        flex-direction: column;

        .message-form {
          margin: 0;

          textarea {
            padding: 10px 0 10px 10px;
          }
        }
      }
    }
  }

  .recording {
    display: flex;
    align-items: center;
    margin-bottom: 20px;

    &.widget {
      margin-top: 10px;
    }

    span {
      margin-inline: 10px;
      cursor: pointer;
    }

    .delete-icon {
      margin-right: 10px;
      color: #1890ff;
      cursor: pointer;
      min-width: 18px;
      min-height: 18px;
      max-width: 18px;
      max-height: 18px;
    }

    .pause-icon {
      color: #1890ff;
      cursor: pointer;
      min-width: 18px;
      min-height: 18px;
    }

    .audio-status {
      margin-inline: 20px;
      font-family: "Roboto";
      font-style: normal;
      font-weight: 400;
      font-size: 16px;
      box-shadow: 0px -4px 12px -8px #8080808c;
    }
  }

  .input-group {
    max-width: 100%;
    width: 100%;
    background: #fff;
    box-shadow: 0px -5px 6px -7px #8080808c;

    .box-input {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: flex-start;
      border-color: rgb(181, 177, 177);
      box-shadow: 0px -4px 12px -8px #8080808c;
      box-sizing: border-box;
      padding-right: 10px;
      padding-left: 25px;
      padding-top: 10px;

      textarea {
        resize: none;
        max-height: 80%;
        max-width: 100%;
      }
    }
  }

  .input-group-widget {
    height: 100%;
    width: 100%;
    right: 0;
    background: #fff;
    box-shadow: 0px -5px 6px -7px #8080808c;

    @media (max-width: 800px) {
    }

    .box-input {
      display: flex;
      flex-direction: row;
      align-items: flex-start;
      justify-content: space-between;

      textarea {
        width: 100%;
        resize: none;
        position: relative;
        padding: 0;
        padding-left: 10px;
      }
    }

    .brand-group {
      margin-bottom: 20px;
    }
  }

  .preview-inputs {
    display: flex;
    align-items: center;
    justify-content: center;

    .buttons-group {
      margin-right: 10px;
      width: 5%;
      display: flex;
      align-items: center;
      justify-content: space-evenly;

      label {
        cursor: pointer;

        .clip-icon {
          color: #1890ff;
          margin-top: 8px;
          min-width: 15px;

          &.widget {
            margin-top: 12px;
          }
        }
      }
    }

    .attach-file {
      min-width: 110px;
      margin: 5px;
      display: flex;
      color: #1890ff;

      .delete-file {
        margin: 5px;
        min-width: 14px;
        max-width: 14px;
        cursor: pointer;
      }
    }
  }

  .brand-group {
    @media (max-width: 780px) {
      height: 50px;
    }
  }

  .form-control.message-input {
    position: relative;
    width: 100%;
    min-height: 52px;
    border: none;

    &.widget {
      width: 70vh;
    }

    &:focus {
      box-shadow: none !important;
      border: none;
      outline: none;
    }

    &.desactive {
      cursor: default;
      z-index: -10;
    }
  }

  .icon-send {
    cursor: pointer;
    margin: 5px 15px 0 auto;

    &.widget {
      margin-top: 12px;
    }

    .paper-plane {
      min-width: 18px;
    }

    .mic-icon {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;

      svg {
        min-width: 12px;
      }

      @media (max-width: 425px) {
        padding-right: 10px;
      }

      color: #1890ff;
    }

    .active-mic-icon {
      animation: active-mic-icon 2s ease-out infinite;
    }
  }

  .loading-msg.neoronChat {
    text-align: center;
    margin: 10px;
    margin-left: 3px;
    background: rgb(255, 255, 255);
    border-radius: 8px;
    border-top-left-radius: 0%;
    padding: 0.3rem 0.5rem 0.3rem;
    max-width: 85px;
    -webkit-box-shadow: 0px 1px 4px 0px #80808073;
    box-shadow: 0px 1px 4px 0px #80808073;
  }

  .off-space-between {
    margin-bottom: 60px;
  }

  .received-chats.neoronChat {
    text-align: left;
    margin: 15px 5px 15px auto;
    background: rgb(77, 75, 75);
    color: #fff;
    border-radius: 8px;
    padding: 0.5rem 0.8rem 0.2rem;
    border-top-right-radius: 0%;
    max-width: 300px;
    width: fit-content;
    min-width: 10%;
    height: auto;
    -webkit-box-shadow: 0px 1px 4px 0px #80808073;
    box-shadow: 0px 1px 4px 0px #b1b1b173;

    .received-msg-inbox {
      a {
        color: #fff;
        text-decoration: none;
        transition: all 0.4s;
      }

      a:hover {
        color: #1890ff;
      }

      div {
        overflow: hidden;
        overflow-wrap: break-word;
      }

      img {
        width: 100%;
      }
    }

    .incoming-chats-img {
      cursor: pointer;
    }

    .received-chats-img {
      width: max-content;
      position: relative;
      right: -1.1rem;
      height: 25px;
      filter: drop-shadow(-1px 2px 2px gray);
      margin-top: 1rem;

      .avatar {
        border-radius: 40%;
      }
    }
  }

  .outgoing-chats {
    text-align: left;
    margin: 5px 4px 6px 0px;
    background: rgb(241, 241, 241);
    border-radius: 8px;
    border-top-left-radius: 0%;
    word-break: break-word;
    padding: 0.8rem 1.5rem;
    max-width: 600px;
    width: fit-content;
    box-shadow: 0px 1px 4px 0px #b1b1b173;

    .outgoing-chats-img {
      max-width: 100%;
      cursor: pointer;
    }
  }

  .time_current {
    span {
      width: auto;
      height: 25px;
      font-size: 14px;
      padding-left: 5px;
      opacity: 0.7;
    }
  }

  .avatar {
    width: 30px;
    height: 30px;
    z-index: 5;
  }

  .spinner {
    margin: 10px auto;
    width: 70px;
    text-align: center;
  }

  .spinner > div {
    width: 10px;
    height: 10px;
    margin-left: 2px;
    background-color: rgb(90, 85, 85);
    border-radius: 100%;
    display: inline-block;
    -webkit-animation: sk-bouncedelay 1.4s infinite ease-in-out both;
    animation: sk-bouncedelay 1s infinite ease-in-out both;
  }

  .spinner .bounce1 {
    -webkit-animation-delay: -0.32s;
    animation-delay: -0.32s;
  }

  .spinner .bounce2 {
    -webkit-animation-delay: -0.16s;
    animation-delay: -0.16s;
  }

  @media screen and (max-width: 451px) {
    .input-group,
    .input-group-widget {
      max-width: 100% !important;
    }
  }

  @media screen and (max-width: 445px) {
    .card-list.simulator-chat {
      height: 44.5vh;
    }
  }

  @media screen and (max-width: 367px) {
  }
}

@-webkit-keyframes sk-bouncedelay {
  0%,
  80%,
  100% {
    background: rgb(100, 95, 95);
  }

  40% {
    background: rgb(168, 166, 166);
  }
}

@keyframes sk-bouncedelay {
  0%,
  80%,
  100% {
    background: rgb(100, 95, 95);
  }

  40% {
    background: rgb(168, 166, 166);
  }
}
</style>

<style lang="scss">
.container-preview {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: #fff;
  @media (max-height: 900px) {
    height: 78%;
  }

  @media (max-height: 850px) {
    height: 77%;
  }

  @media (max-height: 800px) {
    height: 76%;
  }

  @media (max-height: 760px) {
    height: 75%;
  }

  @media (max-height: 720px) {
    height: 74%;
  }

  @media (max-height: 680px) {
    height: 73%;
  }

  #img-preview {
    height: 100%;
    width: 100%;
  }

  @media (max-height: 900px) {
    height: 78%;
    padding-bottom: none;
  }

  @media (max-height: 850px) {
    height: 77%;
  }

  @media (max-height: 800px) {
    height: 76%;
  }

  @media (max-height: 760px) {
    height: 75%;
  }

  @media (max-height: 720px) {
    height: 100%;
  }

  @media (max-height: 680px) {
    height: 73%;
  }

  #video-preview {
    height: 100%;
    width: 100%;
    max-height: 500px;
  }
  .others-documents {
    font-size: 50px !important;
    margin-bottom: 15px;
    margin-right: 30px;
  }
  .file-name {
    margin-bottom: 150px;
    margin-right: 15px;
  }
}

/* Render components */
#modal-form {
  height: 100%;
  width: 100%;
  margin: 0;

  .title-box {
    display: flex;
    align-items: center;

    i {
      margin: 0;
    }

    p {
      margin-left: 10px;
      margin-bottom: 0;
    }
  }

  .ant-modal-body div {
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    min-height: 50px;
  }

  .list-fields {
    .value-text {
      border: 1px solid #c0c0c0;
      border-radius: 3px;
      height: 30px;
      margin: 0 5px;
      max-width: 200px;

      &:hover {
        border: 1px solid #5b65f09f;
      }

      &:focus {
        outline: 1px solid #5b65f09f;
      }
    }
  }

  .ant-modal-footer {
    display: flex;
    align-items: center;
    justify-content: end;

    .list-action-buttons {
      margin: 10px;

      .btn-action {
        outline: none;
        background: #fff;
        border: 1px solid #cecece;
        transition: all 0.5s;
        border-radius: 3px;

        &:hover {
          border: 1px solid #5b65f09f;
          color: #5b65f09f;
        }

        &:focus {
          outline: 1px solid #5b65f09f;
        }
      }
    }
  }
}

#app-neoron.neoronChat {
  width: 100%;

  p {
    white-space: pre-wrap;
    margin-bottom: 0rem;
  }

  .msg-render-chat {
    p {
      img {
        max-width: 100%;
      }
    }

    iframe {
      width: 100%;
    }
  }

  .btn-render-chat {
    background: #ffffffa3;
    border-radius: 6px;
    color: #1890ff;
    border: 0.15rem solid #6686f8;
    width: 100%;
    max-width: 90px;
    transition: all 0.2s;
  }

  .btn-render-chat:hover {
    box-shadow: 0 0 4px 0 #2950db;
  }

  .list-btns-render-chat {
    min-width: 200px;
    min-height: 40px;
    display: grid;
    grid-auto-flow: column;
  }

  .msg-render-chat {
    strong {
      font-weight: bold;
    }
  }

  .fade-enter-active,
  .fade-leave-active {
    transition: all 0.3s ease-in-out;
  }

  .fade-enter {
    transition: all 0.5s linear;
    transform: translateY(0);
    animation: splash linear;
  }

  @keyframes splash {
    0% {
      opacity: 0;
    }

    80% {
      opacity: 0.3;
    }

    100% {
      opacity: 1;
    }
  }
}

.neoronChat {
  @media screen and (max-width: 950px) {
    iframe {
      width: 106%;
      margin: 0 -6px;
    }
  }

  .disclaimer {
    width: 100%;
    text-align: center;
    font-size: 10px !important;
    font-weight: bold;
    font-family: "Nunito", sans-serif;
  }

  .outgoing-chats-msg {
    img {
      max-width: 100% !important;
    }

    .ql-align-center {
      text-align: center;
    }

    .ql-align-right {
      text-align: right;
    }

    .ql-align-justify {
      text-align: justify;
    }

    blockquote {
      background: #f9f9f9;
      border-left: 10px solid #ccc;
      margin: 1.5em 10px;
      padding: 0.5em 10px;
      quotes: "\201C""\201D""\2018""\2019";
    }

    blockquote:before {
      color: #ccc;
      content: open-quote;
      font-size: 4em;
      line-height: 0.1em;
      margin-right: 0.25em;
      vertical-align: -0.4em;
    }

    blockquote p {
      display: inline;
    }
  }
}
</style>
